import { API_URL } from "../../constants/axios";
import { fetchApi } from "../fetch";

export const listMessageCalendar = async (year, month) => {
    const res = await fetchApi.get(`${API_URL.MESSAGE_CALENDAR}?year=${year}&month=${month}`);
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
};

export const listSpecialDate = async (year, month) => {
    const res = await fetchApi.get(`${API_URL.MESSAGE_CALENDAR_SPECIAL_DATE}?year=${year}&month=${month}`);
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
};

export const monthlyMessagesAll = async () => {
    const res = await fetchApi.get(`${API_URL.MESSAGE_CALENDAR_MONTHLY_ALL}`);
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
};

export const includeMonthlyMessage = async (id, flag) => {
    const res = await fetchApi.post(`${API_URL.MESSAGE_CALENDAR_MONTHLY_INCLUDE}`, {
        id,
        flag
    });
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
};